



















import {Component} from "vue-property-decorator";
import {IMaterial} from "shared/entities/material";
import * as icons from "@fortawesome/free-solid-svg-icons";
import {orderBy} from "lodash";
import {Api} from "shared/api";
import AuthMixin from "@/mixins/auth.mixin";
import {apiHandler} from "@/services/api-handler";
import material from "@/views/management/material.vue";

@Component({})
export default class TrainingSection extends AuthMixin {
    icons = icons;
    materials: IMaterial[] = []
    completed: Record<string, boolean> = {};

    async mounted() {
        this.materials = await apiHandler(() => Api.material.Get());
        this.completed = await apiHandler(() => Api.material.completed.Get());
    }

    get orderedMaterials(): IMaterial[] {
        return orderBy(this.materials, ["order"]);
    }

    get highestCompleted() {
        return this.materials
            .filter(m => this.completed[m.id])
            .map(m => m.order)
            .reduce((a, b) => a > b ? a : b, 0);
    }

    get nextOrder() {
        return this.materials
            .filter(m => !this.completed[m.id])
            .map(m => m.order)
            .reduce((a, b) => a < b ? a : b, 9999999);
    }

    iconClass(material: IMaterial) {
        if (this.completed[material.id]) return "text-success";
        if (this.nextOrder === material.order) return "text-primary";
        return "text-muted";
    }

    iconType(material: IMaterial) {
        if (this.completed[material.id]) return "faCheckCircle";
        if (this.nextOrder === material.order) return "faBookOpen";
        return "faExclamationCircle";
    }

    isAccessible(material: IMaterial) {
        return this.completed[material.id] || this.nextOrder === material.order;
    }

    gotoTraining(id: string) {
        const material = this.materials.filter(m => m.id === id)[0];
        if (this.isAccessible(material)) {
            this.$router.push(`/material/${material.id}`);
        } else {
            alert("You must complete the previous training materials first.");
        }
    }
}

